var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2701_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5556 6.6V12C15.5556 12.99 16.3556 13.8 17.3333 13.8H18.2222V20.1C18.2222 20.595 18.6222 21 19.1111 21C19.6 21 20 20.595 20 20.1V4.017C20 3.432 19.4578 3 18.8978 3.135C16.9778 3.612 15.5556 5.259 15.5556 6.6ZM11.1111 9.3H9.33333V3.9C9.33333 3.405 8.93333 3 8.44444 3C7.95556 3 7.55556 3.405 7.55556 3.9V9.3H5.77778V3.9C5.77778 3.405 5.37778 3 4.88889 3C4.4 3 4 3.405 4 3.9V9.3C4 11.289 5.59111 12.9 7.55556 12.9V20.1C7.55556 20.595 7.95556 21 8.44444 21C8.93333 21 9.33333 20.595 9.33333 20.1V12.9C11.2978 12.9 12.8889 11.289 12.8889 9.3V3.9C12.8889 3.405 12.4889 3 12 3C11.5111 3 11.1111 3.405 11.1111 3.9V9.3Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2701_5179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.9b6a73108f453a324f75da5337d1812d.svg";
export { ForwardRef as ReactComponent };